import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { RichText } from "tsi-common-react/src/components/RichText/index";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import iconSpeechBubblesTalk from "../../../assets/svg/speech-bubbles-talk.svg";
import {
    BasketSummaryHelp,
    BasketSummaryHelpChatLink,
} from "../BasketSummaryHelp";

import styles from "./index.module.scss";

export const CheckoutSidebarContent = (): React.ReactNode => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const enableCheckoutSidebarQuestionsBlock = usePageSetting(
        "enable_checkout_sidebar_questions_block",
    );
    const checkoutSidebarExtraContent = usePageSetting(
        "checkout_sidebar_extra_content",
    );
    let questionsBlock: JSX.Element | null = null;
    if (enableCheckoutSidebarQuestionsBlock) {
        questionsBlock = (
            <BasketSummaryHelp>
                <h3>
                    <SVG
                        className={styles.basketSummaryHelpIcon}
                        src={iconSpeechBubblesTalk}
                        title={t`Speech Bubbles Icon`}
                    />
                    {t`Questions?`}
                </h3>
                <div>
                    <BasketSummaryHelpChatLink
                        className={styles.basketSummaryHelpLinkCheckout}
                        chatOfflineLink={contactURL || homeURL}
                    />
                    <br />
                </div>
            </BasketSummaryHelp>
        );
    }
    return (
        <div className={styles.sidebarContent}>
            {questionsBlock}
            <RichText html={checkoutSidebarExtraContent || ""} />
        </div>
    );
};
